// @flow

import React from 'react';
import { withRouter } from 'react-router';
import { Translate } from 'react-redux-i18n';

import KeepeekMediaCarousel from '../../../../common/KeepeekMediaCarousel';
import EventKpi from './EventKpi';
import KeepeekMedia from '../../../../common/KeepeekMedia';
import { parseQueryParams } from '../../../../../utils/urlUtils';
import eventsApi from '../../../../../network/api/eventsApi';
import type { EventDetailsType, EventTileWithOpeningStore } from '../../../../../types/eventType';
import EllipsisLoader from '../../../../../components/EllipsisLoader';
import NoElementFound from '../../../../../components/NoElementFound';
import storesApi from '../../../../../network/api/storesApi';

type Props = {
  location: Location,
  openingEvent?: EventTileWithOpeningStore,
}

type State = {
  event: ?EventDetailsType,
  keepeekCarroussel: {
    id: number,
    keepeekId: number,
    order: number,
  },
  retailerLogo: string,
}

class EventDetails extends React.Component<Props, State> {
  state = {
    event: null,
    keepeekCarroussel: null,
    retailerLogo: '',
  };

  fetchEventDetails() {
    const queryParams = parseQueryParams(this.props.location.search);
    if (queryParams.event) {
      eventsApi.fetchEvent(queryParams.event)
        .then(resp => resp.json())
        .then((event) => {
          this.setState({
            event,
            keepeekCarroussel: !!event && !!event.carrousselKeepek
              && event.carrousselKeepek
                .map((id, index) =>
                  ({
                    id,
                    keepeekId: id,
                    order: index,
                  })),
          });
        });
    } else if (queryParams.opening) {
      storesApi.fetchMainStore(queryParams.opening)
        .then(resp => resp.json())
        .then(resp => this.setState({ retailerLogo: resp.logo, event: null }));
    }
  }

  componentDidMount() {
    this.fetchEventDetails();
  }

  componentDidUpdate(prevProps: Props, prevState: State, s: any) {
    if ((!!prevProps.location && !!this.props.location)
      && prevProps.location.search !== this.props.location.search) {
      this.fetchEventDetails();
    }
  }

  render() {
    const queryParams = parseQueryParams(this.props.location.search);
    if (queryParams.event || queryParams.opening) {
      const { openingEvent } = this.props;
      const { event, retailerLogo } = this.state;
      if (!event && !openingEvent) {
        return (
          <EllipsisLoader />
        );
      }
      return (
        <>
          <div className="event-content-container">
            <div className="event-content-image">
              {event && event.keepeekMainId && <KeepeekMedia keepeekId={event.keepeekMainId} />}
              {
                openingEvent && retailerLogo &&
                  <img src={retailerLogo} alt="logo" className="event-retailer-logo" />
              }
            </div>
            <div className="event-details-container">
              <div className="event-title-container">
                <p className="event-title">
                  {openingEvent ? openingEvent.title : event.name}
                </p>
                {
                  event
                    ? <p className="event-subtitle">{event.subtitle}</p>
                    : <p className="event-subtitle">{openingEvent.info}</p>
                }
                <div className="event-badges">
                  {
                    event && !!event.tags && event.tags.map(name =>
                      (<p className="event-badge event-badge--red" key={name}> {name}</p>))
                  }
                  {
                    openingEvent && <p className="event-badge event-badge--red" key="OPENING"><Translate value="mallData.EVENTS.OPENING" /></p>
                  }
                </div>
              </div>
              {
                event && <div className="event-description">{event.description}</div>
              }
            </div>
          </div>
          {
            event && (
              <div className="event-content-subcontainer">
                <div className="event-KPI">
                  <EventKpi kpis={event.kpis} />
                </div>
                <div className="event-carroussel">
                  {
                    this.state.keepeekCarroussel
                    && (
                      <div className="event-media-container">
                        <KeepeekMediaCarousel
                          medias={this.state.keepeekCarroussel}
                          autoClassName={false}
                        />
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }
        </>
      );
    }
    return (
      <NoElementFound text={<Translate value="mallData.EVENTS.NO_EVENTS" />} />
    );
  }
}

export default withRouter(EventDetails);
